import { useState } from 'react';
import type { GetMemberRequestsAvailabilityResponse } from 'shared/src/api/memberRequestsAvailabilityService/getMemberRequestsAvailability';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useRetainedEffect } from 'shared/src/hooks/retainedState';

export const useLogDisplayRequestCoupon = (
  memberRequestAvailable?: GetMemberRequestsAvailabilityResponse,
) => {
  const [isLogged, setIsLogged] = useState(false);
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  useRetainedEffect(
    'market-home-display-request-coupon',
    () => {
      if (isLogged) return;

      if (memberRequestAvailable) {
        if (memberRequestAvailable.availability.is_available_request) {
          logMarketAnalytics({
            name: 'DISPLAY_REQUEST_COUPON',
          });
          setIsLogged(true);
        }
      }
    },
    [logMarketAnalytics, memberRequestAvailable, isLogged],
  );
};
